import styled, { css } from 'styled-components'
import { colors } from '../../const'

export const HomeContainer = styled.div`
  min-height: 100vh;
  background-color: ${colors.pageBackground};
`

export const MainContent = styled.main`
  position: relative;
  padding: 32px 16px;
  margin: 0 auto;
  max-width: 1280px; // Equivalent to container mx-auto
`

export const LogoWrapper = styled.div`
  text-align: center;
  margin-bottom: 48px;
`

export const Logo = styled.img`
  margin-top: 3%;
  width: 220px;
`

export const Subtitle = styled.p`
  color: ${colors.textSecondary};
  font-size: 1.1rem;
  font-weight: 500;
`

export const CardsGrid = styled.div(({ admin }) => css`
  display: grid;
  justify-content: center;
  align-items: center;
  grid-template-columns: repeat(auto-fit, minmax(${admin ? 250 : 300}px, 1fr));
  gap: 3%;
  ${admin ? 'width: 100%;' : 'max-width: 1000px;'}
  margin: 0 auto;

  @media (min-width: 768px) {
    gap: 32px;
  }
`)

export const VersionWrapper = styled.div`
  margin-top: 32px;
  text-align: center;
`

export const TechnicalContext = styled.div`
  position: absolute;
  bottom: 24px;
  right: 24px;
  z-index: 100;
  display: inline-flex;
  align-items: center;
  background-color: ${colors.secondaryContainer};
  color: ${colors.onSecondaryContainer};
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.85rem;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  opacity: 0.8;
  transition: opacity 0.2s ease-in-out;

  &:hover {
    opacity: 1;
  }
`

export const ContextIcon = styled.span`
  margin-right: 8px;
  font-size: 1.1rem;
`

export const ContextText = styled.span`
  color: ${colors.onSecondaryContainer};
`
